import axios from "../axios-auth";
import orginal_axios from "axios";

export const purchaseOrderService = {
  getPurchaseOrderList,
  savePurchaseOrder,
  getPurchaseOrderDetail,
  exportPurchaseOrderExcel,
  getAllPurchaseOrderList,
};

function getPurchaseOrderList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.supplierId) {
    params["supplierId"] = searchParams.supplierId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.restrictAlreadyRegisteredPoNoFlag) {
    params["restrictAlreadyRegisteredPoNoFlag"] = searchParams.restrictAlreadyRegisteredPoNoFlag;
  }

  return axios.get("/auth/purchase-order", { params });
}

function savePurchaseOrder(purchaseOrder) {
  if (!purchaseOrder.id) {
    // new purchase order
    return axios.post("/auth/purchase-order", purchaseOrder);
  } else {
    // edit
    return axios.put("/auth/purchase-order", purchaseOrder);
  }
}

function getPurchaseOrderDetail(id) {
  return axios.get("/auth/purchase-order/" + id);
}

function exportPurchaseOrderExcel(searchParams) {
  let params = {
    sort: "warehouseName,asc"
  };
  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.supplierId) {
    params["supplierId"] = searchParams.supplierId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.isStockInRegisterFlag) {
    params["isStockInRegisterFlag"] = searchParams.isStockInRegisterFlag;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/purchase-order/purchase-order-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
function getAllPurchaseOrderList(searchParams) {
  let params = {
    sort: "warehouseName,asc"
  };
  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.supplierId) {
    params["supplierId"] = searchParams.supplierId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.isStockInRegisterFlag) {
    params["isStockInRegisterFlag"] = searchParams.isStockInRegisterFlag;
  }

  return axios.get("/auth/purchase-order", { params });
}